/* eslint no-useless-escape: 0 */

'use strict';

export default {
  methods: {
    getSolicitantes (filter) {
      this.$service.graphql({
        query: `
          query getSolicitantes {
            solicitantes {
              count
              rows {
                id
                nombres
                primer_apellido
                segundo_apellido
              }
            }
          }
        `,
        variables: {}
      }).then(response => {
        if (response) {
          let items = response.solicitantes.rows;
          let solicitantes = [];
          items.map(solicitante => {
            solicitantes.push({ value: solicitante.id, text: solicitante.nombres + ' ' + solicitante.primer_apellido + ' ' + solicitante.segundo_apellido });
          });
          this.solicitantes = solicitantes;
          if (filter && this.filters[filter] && this.filters[filter].items) {
            this.filters[filter].items = this.solicitantes;
          }
        }
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/eRegister/tramite/mixins/tramite.js